export const SEEK_BEGAN = 'history/SEEK_BEGAN'
export const SEEK_SUCCESS = 'history/SEEK_SUCCESS'
export const SEEK_COMPLETE = 'history/SEEK_COMPLETE'
export const SEEK_FAILED = 'history/SEEK_FAILED'

export const UPDATE_BEGAN = 'history/UPDATE_BEGAN'
export const UPDATE_SUCCESS = 'history/UPDATE_SUCCESS'
export const UPDATE_FAILED = 'history/UPDATE_FAILED'

export const UPDATE_CELLS_BEGAN = 'history/UPDATE_CELLS_BEGAN'
export const UPDATE_CELLS_SUCCESS = 'history/UPDATE_CELLS_SUCCESS'
export const UPDATE_CELLS_FAILED = 'history/UPDATE_CELLS_FAILED'

export const SEEK_CELLS_BEGAN = 'history/SEEK_CELLS_BEGAN'
export const SEEK_CELLS_SUCCESS = 'history/SEEK_CELLS_SUCCESS'
export const SEEK_CELLS_COMPLETE = 'history/SEEK_CELLS_COMPLETE'
export const SEEK_CELLS_FAILED = 'history/SEEK_CELLS_FAILED'

export const SET_FETCH_ID = 'history/SET_FETCH_ID'

export const SET_CELLS = "history/SET_CELLS"

export const CLEAR_HISTORY = 'history/CLEAR_HISTORY'